"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("../common");
var dateHelpers_1 = require("./dateHelpers");
var constants_1 = require("../constants");
var formatHelpers_1 = require("./formatHelpers");
var validator_1 = require("./validator");
/**
 * Extract only calendar string part
 * @param iCalString
 */
var getVCalendarString = function (iCalString) {
    return iCalString.slice(0, iCalString.indexOf(constants_1.EVENT_BEGIN_KEY_VALUE));
};
/**
 * Parse calendar string to calendar JSON
 * @param calendarString
 */
var formatVCalendarStringToObject = function (calendarString) {
    var calendarRows = formatHelpers_1.splitRowsToArray(calendarString);
    var result = {};
    for (var _i = 0, calendarRows_1 = calendarRows; _i < calendarRows_1.length; _i++) {
        var row = calendarRows_1[_i];
        var keyValue = splitRowToKeyValueObj(row);
        var key = keyValue.key, value = keyValue.value;
        result[key] = value;
    }
    return result;
};
/**
 * Split string events to array
 * @param iCalEvents
 */
var splitStringEvents = function (iCalEvents) {
    // Get array of events
    var result = iCalEvents.split(constants_1.EVENT_BEGIN_KEY_VALUE).slice(1);
    if (!result) {
        return '';
    }
    // Add missing delimiter from split to each record
    result = result.map(function (item) { return "" + constants_1.EVENT_BEGIN_KEY_VALUE + item; });
    return result;
};
/**
 * Temporary solution to remove valarms in recursion
 * @param vEventsString
 * @param count
 */
var removeVAlarm = function (vEventsString, count) {
    if (count === void 0) { count = constants_1.VALARM_RECURSION_MAX_COUNT; }
    var eventStringResult = vEventsString;
    var indexOfBeginVAlarm = eventStringResult.indexOf('BEGIN:VALARM');
    var indexOfEndVAlarm = eventStringResult.indexOf('END:VALARM');
    if (indexOfBeginVAlarm !== -1 && count > 0) {
        eventStringResult =
            eventStringResult.slice(0, indexOfBeginVAlarm) +
                eventStringResult.slice(indexOfEndVAlarm + 'END:VALARM'.length);
        removeVAlarm(eventStringResult, count - 1);
    }
    return eventStringResult;
};
var getOneEventJSON = function (rawString) {
    var eventObj = {};
    // Format event string, merge multiline values
    var eventWithMergedRows = formatHelpers_1.splitRowsToArray(rawString);
    for (var _i = 0, eventWithMergedRows_1 = eventWithMergedRows; _i < eventWithMergedRows_1.length; _i++) {
        var stringEvent = eventWithMergedRows_1[_i];
        var keyValue = splitRowToKeyValueObj(stringEvent);
        var key = keyValue.key, value = keyValue.value;
        // Handle nested array value so it does not override with same key like ATTENDEE
        if (key === constants_1.ATTENDEE_KEY) {
            eventObj[constants_1.ATTENDEE_KEY] = Array.isArray(eventObj[constants_1.ATTENDEE_KEY])
                ? __spreadArrays(eventObj[constants_1.ATTENDEE_KEY], [value]) : [value];
        }
        else {
            eventObj[key] = value;
        }
    }
    return eventObj;
};
/**
 * Split string to separate key and value
 * @param item
 */
var splitRowToKeyValueObj = function (item) {
    // Get basic delimiter indexes
    var basicDelimiterIndex = item.indexOf(':');
    var nestedDelimiterIndex = item.indexOf(';');
    // Check if item has nested values
    var hasNestedValues = nestedDelimiterIndex !== -1 && nestedDelimiterIndex < basicDelimiterIndex;
    var key;
    var value;
    // Set keys first
    if (hasNestedValues &&
        item.slice(0, nestedDelimiterIndex) !== constants_1.RRULE_ICAL_KEY) {
        key = formatHelpers_1.normalizeKey(item.slice(0, nestedDelimiterIndex));
    }
    else {
        key = formatHelpers_1.normalizeKey(item.slice(0, basicDelimiterIndex));
    }
    // Check if key is date parameter
    var isDateKey = common_1.checkIfIsDateKey(key);
    // Set values
    if (hasNestedValues && constants_1.ALWAYS_STRING_VALUES.indexOf(key) !== -1) {
        // Should format nested values summary, location and description to simple
        // string
        value = formatHelpers_1.extractAlwaysStringValue(item);
    }
    else if (hasNestedValues && key !== constants_1.RRULE_KEY) {
        value = isDateKey
            ? formatHelpers_1.normalizeString(item.slice(nestedDelimiterIndex + 1))
            : parseNestedValues(item.slice(nestedDelimiterIndex + 1));
    }
    else {
        value = formatHelpers_1.normalizeString(item.slice(basicDelimiterIndex + 1));
    }
    if (isDateKey) {
        value = formatHelpers_1.normalizeString(dateHelpers_1.parseICalDate(value));
    }
    // UID cant have any space between chars
    if (key === constants_1.UID_KEY) {
        value = value.replace(' ', '');
    }
    return {
        key: key,
        value: value,
    };
};
/**
 * Split item to key and nested values
 * @param item
 */
var splitNestedValues = function (item) {
    var nestedValueDelimiterIndex = item.indexOf('=');
    return {
        key: formatHelpers_1.normalizeKey(item.slice(0, nestedValueDelimiterIndex)),
        value: item.slice(nestedValueDelimiterIndex + 1),
    };
};
/**
 * Split values to nested obj, except date key
 * @param values
 */
var parseNestedValues = function (values) {
    var result = {};
    // Separate key values with ; delimiter
    var valuesArray = values.split(';');
    for (var _i = 0, valuesArray_1 = valuesArray; _i < valuesArray_1.length; _i++) {
        var item = valuesArray_1[_i];
        var keyValue = splitNestedValues(item);
        var key = keyValue.key, value = keyValue.value;
        // ** Handle exception with date in nested value ** //
        // f.e. date without time
        if (key === 'value' && value.indexOf('DATE') !== -1) {
            result = formatHelpers_1.normalizeString(value.slice(value.indexOf('DATE')));
        }
        else if (value.indexOf(constants_1.MAILTO_KEY_WITH_DELIMITER) !== -1) {
            result[key.toUpperCase()] = formatHelpers_1.normalizeString(value
                .slice(0, value.indexOf(constants_1.MAILTO_KEY_WITH_DELIMITER))
                .replace(' ', ''));
            result[constants_1.MAILTO_KEY] = formatHelpers_1.normalizeString(value.slice(value.indexOf(constants_1.MAILTO_KEY_WITH_DELIMITER + ":") +
                (constants_1.MAILTO_KEY_WITH_DELIMITER + ":").length));
        }
        else {
            result[key.toUpperCase()] = formatHelpers_1.normalizeString(value);
        }
    }
    return result;
};
/**
 * Main function
 * Get key values from each line to build obj
 * @param iCalStringEvent
 */
var toJSON = function (iCalStringEvent) {
    // Validate string
    validator_1.validateICalString(iCalStringEvent);
    // Get vcalendar props
    var vCalendarString = getVCalendarString(iCalStringEvent);
    var calendar = formatVCalendarStringToObject(vCalendarString);
    // Get events
    var vEventsString = iCalStringEvent.slice(vCalendarString.length, iCalStringEvent.length - constants_1.CALENDAR_END_KEY_VALUE.length);
    // Remove valarms //TODO add in future?
    vEventsString = removeVAlarm(vEventsString);
    // Split string events to array
    var vEventsArray = splitStringEvents(vEventsString);
    // Parse each event to obj
    var events = vEventsArray.map(function (stringEvent) {
        return getOneEventJSON(stringEvent);
    });
    return {
        calendar: calendar,
        events: events,
    };
};
exports.default = toJSON;
